import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class NodesByNetworkDomainChart extends Component {
  constructor(props) {
    super(props);
    const colors = ["#EA5324"];

    this.state = {
      series: [
        {
          name: "",
          data: [30, 40, 45, 50, 60, 70, 80, 9],
        },
      ],
      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "SEM",
            "HFC Network",
            "EAN",
            "FTTP",
            "FTTN",
            "DWDM",
            "FTTB",
            "LI",
          ],
          title: {
            text: "Network Domain", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        yaxis: {
          title: {
            text: "Nodes", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 700,
          },
          background: {
            enabled: true,
            foreColor: "#656161",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#656161",
          },
          offsetY: -20,
        },
        legend: {
          show: false,
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "90%",
            distributed: true,
            borderRadius: 5,
            dataLabels: {
              position: "top",
            },
          },
        },
      },
    };
  }
  render() {
    return (
      <div>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={200}
        />
      </div>
    );
  }
}
